import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';

const OfferButtons = ({ removeClick, removeAllClick }) => {

    const renderStatusButtons = () => {

        return (
            <Row>
                <ButtonRow variant="danger" onClick={removeClick} text="Remove Selected" />
                <ButtonRow variant="danger" onClick={removeAllClick} text="Remove All" />
            </Row>
        );

    };

    // Helper Component for Status Buttons
    const ButtonRow = ({ variant, onClick, text }) => (
        <Col>
            <Button variant={variant} className="me-2" onClick={onClick}>
                {text}
            </Button>
        </Col>
    );

    return (
        <div>
            {renderStatusButtons()}
        </div>
    );
};

export default OfferButtons;